import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_LOCATIONS } from "../../../utils/constants";
import { LocationInterface } from "../../../models/TicketModule/Location";
import locationService from "../../../services/ticketService/locationService";

const useLocations = (page: number, pageSize: number) =>
  useQuery<LocationInterface[], Error>({
    queryKey: [
      CACHE_KEY_LOCATIONS,
      page > 0 ? page : null,
      pageSize > 0 ? pageSize : null,
    ],
    queryFn: () => locationService.GetAll(page, pageSize),
  });

export default useLocations;
